export default ({ contact, physicianUserId }) =>
  contact.type === 'staff' || (physicianUserId && contact.user.id === physicianUserId);
